var CurrentUser = require("lib/account/CurrentUser");
var WhooosReadingServices = require("lib/web/WhooosReadingServices");
var Spinner = require("components/utility/Spinner");

class SignoutPage extends React.Component {
	render() {
		return (
			<div className="signoutPage container">
				<Spinner placeholder={ true } scale={ 1.5 } />
			</div>
		)
	}

	componentDidMount() {
		CurrentUser.logOut();
	}
};

SignoutPage.propTypes = PageStrictPropTypes({
});

module.exports = SignoutPage;


// WEBPACK FOOTER //
// ./modules/components/logins/SignoutPage.js